<template>
    <van-nav-bar
        :title="title"
        :border="false"
        :fixed="fixed"
        :right-text="rightText"
        :left-arrow="leftArrow"
        :class="[{'white': theme === 'white'}, {'absolute': absolute}]"
        @click-left="onClickLeft"
        @click-right="onClickRight">
        <template #left>
            <views v-if="leftArrow" class="icon">
                <images :src="theme === 'white' ? leftWhiteIcon : leftIcon"></images>
            </views>
        </template>
    </van-nav-bar>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        rightText: {
            type: String,
            default: ''
        },
        leftArrow: {
            type: Boolean,
            default: true
        },
        fixed: {
            type: Boolean,
            default: false
        },
        absolute: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            leftIcon: require('@/assets/images/arrow_left.png'),
            leftWhiteIcon: require('@/assets/images/arrow_left_white.png')
        }
    },
    methods: {
        onClickLeft() {
            this.$emit('click-left')
        },
        onClickRight() {
            this.$emit('click-right')
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>
